import { render, staticRenderFns } from "./SubModulesCountWidget.vue?vue&type=template&id=81b1873c&"
import script from "./SubModulesCountWidget.vue?vue&type=script&lang=js&"
export * from "./SubModulesCountWidget.vue?vue&type=script&lang=js&"
import style0 from "./SubModulesCountWidget.vue?vue&type=style&index=0&id=81b1873c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports